import React from 'react';
import classNames from 'classnames';
import { keyCodes } from '../../constants';
import Box from '../box';
import Stack from '../stack';
import Heading from '../heading';
import SelectedIcon from '../selected-icon';
import ActionGroup from './components/action-group';
import Tooltip from '../tooltip';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const PresetContainer = ({
  title = '',
  isSelected = false,
  editLabel = '',
  deleteLabel = '',
  withTitleTooltip = false,
  children,
  onClick,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onEditClick = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onDeleteClick = null,
}) => {
  const nonInteractive = !onClick && !onEditClick && !onDeleteClick;

  const isInteractive = !isSelected && !nonInteractive;

  const containerClasses = classNames('ws-ui-preset-container', {
    'ws-ui-preset-container--interactive': isInteractive,
    'ws-ui-preset-container--selected': isSelected,
  });

  const titleClasses = classNames('ws-ui-preset-container__title', {
    'ws-ui-preset-container__title--with-icon':
      // @ts-ignore TS(2774): This condition will always return true since this ... Remove this comment to see the full error message
      (onEditClick && !onDeleteClick) || (onDeleteClick && !onEditClick),
    // @ts-ignore TS(2774): This condition will always return true since this ... Remove this comment to see the full error message
    'ws-ui-preset-container__title--with-two-icons': onEditClick && onDeleteClick,
    'ws-ui-preset-container__title--selected': isSelected,
  });

  const handleKeyDown = (e) => {
    if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.ENTER) {
      e.preventDefault();
      onClick();
    }
  };

  const interactiveProps = {
    role: 'button',
    tabIndex: '0',
    onKeyDown: handleKeyDown,
  };

  return (
    // @ts-ignore TS(2322): Type '{ children: Element; role?: string | undefin... Remove this comment to see the full error message
    <div className={containerClasses} onClick={onClick} {...(isInteractive && interactiveProps)}>
      {/* @ts-ignore TS(2322): Type '{ children: Element; padding: string; paddin... Remove this comment to see the full error message */}
      <Box padding="spacing-xs" paddingTop="spacing-2-xs">
        <Stack gap="spacing-xs">
          {title && (
            <div className="ws-ui-preset-container__header">
              {isSelected && (
                <div className="ws-ui-preset-container__selected-icon">
                  <SelectedIcon />
                </div>
              )}
              {withTitleTooltip ? (
                <div className={titleClasses} data-tip data-for={title}>
                  <Heading type="heading-6" singleLine>
                    {title}
                  </Heading>
                  <Tooltip text={title} id={title} />
                </div>
              ) : (
                <Heading type="heading-6" singleLine>
                  {title}
                </Heading>
              )}
              <ActionGroup
                editLabel={editLabel}
                deleteLabel={deleteLabel}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
              />
            </div>
          )}
          <div className="ws-ui-preset-container__content">{children}</div>
        </Stack>
      </Box>
    </div>
  );
};

export default PresetContainer;
